module.exports = __webpack_public_path__ + "img/nuage_off.80b713d6.gif";